var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14V34H38V14H10ZM38 10C40.2 10 42 11.8 42 14V34C42 36.2 40.2 38 38 38H10C7.8 38 6 36.2 6 34V14C6 11.8 7.8 10 10 10H38Z",
    fill: "#278B9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.996 13H6.248C6.546 13.88 7.046 14.708 7.748 15.41L19.512 27.172C20.0909 27.7514 20.7784 28.2111 21.5351 28.5247C22.2918 28.8384 23.1029 28.9998 23.922 28.9998C24.7411 28.9998 25.5522 28.8384 26.3089 28.5247C27.0656 28.2111 27.7531 27.7514 28.332 27.172L40.096 15.41C40.796 14.708 41.296 13.88 41.594 13H36.848L25.504 24.344C25.2962 24.552 25.0494 24.7169 24.7778 24.8295C24.5062 24.9421 24.215 25 23.921 25C23.627 25 23.3358 24.9421 23.0642 24.8295C22.7926 24.7169 22.5458 24.552 22.338 24.344L10.996 13Z",
    fill: "#278B9F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.488d6f0697ad73d0a28f8d24a8acf2cc.svg";
export { ForwardRef as ReactComponent };